import { Component, Input, EventEmitter, Output} from '@angular/core';



/**
   * Logger Factory
   * @namespace items: menu item to show
   * @namespace alignLeft: if true the box is aligned to left 
   * @namespace clickItem: is the action brought to the parent
   * <ute-menu-dropdown [items]="menuitems" (clickItem)="onClickItem($event)"></ute-menu-dropdown>
*/

@Component({
  selector: 'ute-menu-dropdown',
  templateUrl: 'ute-menu-dropdown.component.html'
})
export class UteMenuDropdown  {
  @Input() items: any;
  @Input() alignLeft: boolean = false;
  @Output() clickItem = new EventEmitter;

  public isOpen: boolean = false;

  constructor() {}

  openDropdown(){
    this.isOpen = !this.isOpen;
  }

  onClickItem(action){
    this.clickItem.emit(action);
    this.isOpen = !this.isOpen;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-menu-dropdown/ute-menu-dropdown.component.ts